import React from "react";
const SupportTicketConfirmation = ({ ticketNumber }) => {
  return (
    <>
      <h1>Thank you for contacting Support!</h1>
      <h2>Your ticket has been submitted successfully!</h2>
      <h2>Ticket number: {ticketNumber}</h2>

      <div>
        <h3>What happens next?</h3>
        <ul>
          <li>You should receive a confirmation email from Digital Gateway within the next few minutes (please check Spam as well if you do not see anything in your inbox).</li>
          <li>The email will include a link where you can track the status of the ticket.</li>
        </ul>
      </div>

      <div>
        <h3>Helpful Resources</h3>
        <div>
          You may find these resources helpful while you wait:
        </div>
        <ul>
          <li><a href="/help/faq" target="_blank" rel="noreferrer">FAQ</a></li>
          <li><a href="/apis" target="_blank" rel="noreferrer">Explore APIs</a></li>
        </ul>
      </div>
    </>
  );
};

export default SupportTicketConfirmation;
